/**
 * Settings dialog · Scopes tab — design_handoff_integrations_page frame 22.
 * Same building blocks as the connect flow's step 1 (ScopeRow,
 * scopeDefinitions) but flat — no nested Scopes card/heading, since the
 * dialog itself is already the containing surface (frame 22 composes
 * explainer()+scope() directly, not the scopesCard() wrapper used on the
 * connect page).
 */
import React, { useMemo } from "react";
import ScopeRow from "../../IntegrationConnectPage/ScopeRow";
import { SCOPE_DEFINITIONS } from "../../IntegrationConnectPage/scopeDefinitions";
import { INTEGRATION_NAMES } from "../../../../../consts";
import styles from "./IntegrationSettingsDialog.module.scss";

const dateFormatter = new Intl.DateTimeFormat(
  window.navigator.language || "en-US",
  { year: "numeric", month: "short", day: "numeric" }
);

const ScopesTab = ({ integration, scopes, onScopeChange }) => {
  const definitions = SCOPE_DEFINITIONS[integration.type];
  const providerName = INTEGRATION_NAMES[integration.type];

  const grantedDate = useMemo(() => {
    const earliest = (integration.integration_scopes || []).reduce(
      (min, s) => (min === null || s.created < min ? s.created : min),
      null
    );
    return earliest ? dateFormatter.format(new Date(earliest * 1000)) : null;
  }, [integration.integration_scopes]);

  const scopeRows = Object.keys(definitions).map((name) => (
    <ScopeRow
      key={name}
      name={name}
      definition={definitions[name]}
      checked={Boolean(scopes[name])}
      onChange={onScopeChange}
    />
  ));

  return (
    <div>
      <p className={styles.cap}>
        Granted by <b className={styles.capStrong}>{integration.username}</b>
        {grantedDate ? ` on ${grantedDate}.` : "."}
      </p>
      <ul className={styles.scin}>{scopeRows}</ul>
      <p className={styles.hint}>
        Click the button below to apply changes to your {providerName}{" "}
        integration. Signing in leaves Revisual and returns you to this
        connection.
      </p>
    </div>
  );
};

export default ScopesTab;
